export default {
  roomQuestionList: [],
  currentQuestion: {},
  newQuestionAlertFun: null,
  isNewQuestion: false,
  isModalQuestion: false,
  questionOpenStatus: false,
}